import React from 'react';

const tuneFilterComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
        <path d="M450.001-130.001v-219.998h59.998v80h320v59.998h-320v80h-59.998Zm-320-80v-59.998h219.998v59.998H130.001Zm160-160v-80h-160v-59.998h160v-80h59.998v219.998h-59.998Zm160-80v-59.998h379.998v59.998H450.001Zm160-160v-219.998h59.998v80h160v59.998h-160v80h-59.998Zm-480-80v-59.998h379.998v59.998H130.001Z"/>
    </svg>
);

export default tuneFilterComponent;